import { render, staticRenderFns } from "./HtmlBlock.form-builder.vue?vue&type=template&id=65ad7207&"
import script from "./HtmlBlock.form-builder.vue?vue&type=script&lang=js&"
export * from "./HtmlBlock.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports